import { Component } from 'react';

class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = { startDate: Date.now(), elapsedTime: 0 };
    this.timerID = null;
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  formatTime(seconds) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    // eslint-disable-next-line no-nested-ternary
    return [h, m > 9 ? m : h ? `0${m}` : m || '0', s > 9 ? s : `0${s}`]
      .filter(Boolean)
      .join(':');
  }

  tick() {
    const { startDate } = this.state;
    this.setState({
      elapsedTime: Math.round((Date.now() - startDate) / 1000),
    });
  }

  render() {
    const { elapsedTime } = this.state;
    return (
      <span style={{ width: '30px' }}>{this.formatTime(elapsedTime)}</span>
    );
  }
}

export default Timer;
